import React from 'react';
import {PropTypes} from 'prop-types';
import {SimpleTooltip} from './tooltip';

import './refreshbutton.scss';
import {NormalizeClassNameString, ObjectHasProperty} from './utils';

export class RefreshButtonComponent extends React.Component {
    render() {
        const self = this;
        const {visible, animated, disabled, onClick, tooltip, type} = self.props;

        if (!visible || (typeof onClick !== 'function') && (type !== 'submit')) {
            return null;
        }

        let props = {...self.props};

        props.className = NormalizeClassNameString('btn-refresh text-body ' + (props.className || ''));

        delete props.visible;
        delete props.animated;
        delete props.tooltip;

        const button = 
            <button {...props}>
                <span className={'sbkico-reload' + (animated ? ' fa-spin' : '')} />
            </button>;

        if (Boolean(tooltip)) {
            if (ObjectHasProperty(tooltip, 'visible')) {
                tooltip.visible = Boolean(tooltip.visible) && !disabled;
            }
            else {
                tooltip.visible = !disabled;
            }

            return <SimpleTooltip {...tooltip}>{button}</SimpleTooltip>;
        }
        else {
            return button;
        }
    }
}
RefreshButtonComponent.propTypes = {
    visible: PropTypes.bool,
    animated: PropTypes.bool,
    disabled: PropTypes.bool,
    tooltip: PropTypes.object,
    type: PropTypes.oneOf(['button', 'submit']).isRequired
}
RefreshButtonComponent.defaultProps = {
    visible: true,
    animated: false,
    type: 'button'
}
RefreshButtonComponent.void = () => {};